var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',[_vm._v("ERRUR 404. Pas de panique, ceci n'est pas une arnaque, mais quelque chose s'est mal passé")])}
var staticRenderFns = []

export { render, staticRenderFns }